// extracted by mini-css-extract-plugin
module.exports = {"con":"CustomButton_con__o-0Ad","button":"CustomButton_button__3k4vD"};